import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiX, FiSearch, FiShare } from "react-icons/fi";
import { clearForwardingMessage, forwardMessageThunk } from "../../../Slices/chatSlice";
import { getDisplayName, getInitials, getAvatarColor } from "./avatarUtils";

const ForwardDialog = () => {
  const dispatch = useDispatch();
  const forwardingMessage = useSelector((state) => state.chat.forwardingMessage);
  const conversations = useSelector((state) => state.chat.conversations);
  const activeConversationId = useSelector((state) => state.chat.activeConversationId);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const allUsers = useSelector((state) => state?.loginUserInfo?.allUsers);
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    return conversations
      .filter((c) => c.id !== activeConversationId)
      .filter((c) => {
        if (!search) return true;
        const name = getDisplayName(c, loginUser?.id, allUsers) || "";
        return name.toLowerCase().includes(search.toLowerCase());
      });
  }, [conversations, activeConversationId, loginUser?.id, allUsers, search]);

  if (!forwardingMessage) return null;

  const handleForward = (targetConversationId) => {
    const userName = loginUser?.firstname
      ? `${loginUser.firstname} ${loginUser.lastname || ""}`.trim()
      : "User";

    dispatch(forwardMessageThunk({
      originalMessageId: forwardingMessage.messageId,
      targetConversationId,
      senderId: loginUser?.id,
      senderName: userName,
    }));
    dispatch(clearForwardingMessage());
  };

  const handleClose = () => {
    dispatch(clearForwardingMessage());
  };

  return (
    <div className="forward-dialog__overlay" onClick={handleClose}>
      <div className="forward-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="forward-dialog__header">
          <FiShare size={16} />
          <span>Forward message</span>
          <button className="forward-dialog__close" onClick={handleClose} type="button">
            <FiX size={18} />
          </button>
        </div>

        <div className="forward-dialog__search">
          <FiSearch size={14} />
          <input
            type="text"
            placeholder="Search conversations..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
        </div>

        <div className="forward-dialog__preview">
          <span className="forward-dialog__preview-label">Message:</span>
          <span className="forward-dialog__preview-text">
            {forwardingMessage.content?.substring(0, 80) || "File attachment"}
          </span>
        </div>

        <div className="forward-dialog__list">
          {filtered.map((conv) => {
            const name = getDisplayName(conv, loginUser?.id, allUsers);
            const otherUserId = conv.type === "direct"
              ? conv.participants?.find((p) => p.userId !== loginUser?.id)?.userId
              : null;
            return (
              <button
                key={conv.id}
                className="forward-dialog__item"
                onClick={() => handleForward(conv.id)}
                type="button"
              >
                <div
                  className="chat-avatar chat-avatar--sm"
                  style={{ background: getAvatarColor(otherUserId || conv.id) }}
                >
                  {getInitials(name?.split(" ")[0], name?.split(" ")[1])}
                </div>
                <span className="forward-dialog__item-name">{name}</span>
              </button>
            );
          })}
          {filtered.length === 0 && (
            <div className="forward-dialog__empty">No conversations found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForwardDialog;
